const dummy_t = (translationKey) => translationKey;

export default [
  {
    path: '/how-to',
    translationKey: dummy_t('footer.serviceAccess'),
  },
  {
    path: '/terms-of-service',
    translationKey: dummy_t('footer.tos'),
  },
  {
    path: '/privacy-policy',
    translationKey: dummy_t('footer.privacyPolicy'),
  },
  {
    externalPath: {
      'en-US': 'https://joinradiance.zendesk.com/hc/en-us',
      'pt-BR': 'https://radiance-br.zendesk.com/hc/pt-br',
    },
    translationKey: dummy_t('footer.contact'),
  },
];
